import React from "react";
import { toast } from "react-hot-toast";
import { apiConnector } from "../apiconnector";

import { catalogData } from "../apis";

// export async function getCatalogPageData(categoryId) {
//     const toastId = toast.loading("Loading....");
//     console.log("category id: ",categoryId);
//     let result = [];
//     try
//     {
//         const response = await apiConnector("POST",catalogData.CATALOGPAGEDATA_API,{categoryId: categoryId});
//         console.log("Respons from api: ",response)
//         if(!response?.data?.success)
//         {
//             throw new Error("Could not fetch category page data");
//         }

//         result = response?.data;

//     }
//     catch(e)
//     {
//         console.log("Catalog page data api error: ",e);
//         toast.error(e.message);
//         result = e.response?.data;
//     }

//     console.log("Result:",result)
//     toast.dismiss(toastId);
//     return result;
// }

export const getCatalogPageData = async (categoryId) => {
  const toastId = toast.loading("Loading...")
  console.log("Category id: ",categoryId)
  let result = []
  try {
    const response = await apiConnector(
      "POST",
      catalogData.CATALOGPAGEDATA_API,
      {
        categoryId: categoryId,
      }
    )
    console.log("Response from api",response)
    if (!response?.data?.success) {
      throw new Error("Could Not Fetch Catagory page data.")
    }
    result = response?.data
  } catch (error) {
    console.log("CATALOGPAGEDATA_API API ERROR............", error)
    toast.error(error.message)
    result = error.response?.data
  }
  toast.dismiss(toastId)
  console.log("Result: ",result)
  return result
}